// コンバート履歴モーダル
const ModalConvertHistory = {
  namespaced: true,

  state: {
    modal: false,
    shopId: null,
    portalSiteCd: '',
  },
  getters: {
    getModal: state => {
      return state.modal
    },
    getShopId: state => {
      return state.shopId
    },
    getPortalSiteCd: state => {
      return state.portalSiteCd
    },
  },
  mutations: {
    setModal(state, modal) {
      state.modal = modal
    },
    setShopId(state, shopId) {
      state.shopId = shopId
    },
    setPortalSiteCd(state, portalSiteCd) {
      state.portalSiteCd = portalSiteCd
    },
  },
  actions: {
    set({ commit }, item) {
      commit('setShopId', item.shopId)
      commit('setPortalSiteCd', item.portalSiteCd)
      commit('setModal', true)
    },
    reset({ commit }) {
      commit('setModal', false)
      commit('setPortalSiteCd', '')
      commit('setShopId', null)
    },
  },
}

export default ModalConvertHistory
